import { apiClient } from '../client/apiClient';
import type { IBaseResponse } from '../types/common';
import type { ISearch } from '../types/search';

export const searchService = {
	/**
	 * Search across conversations, categories, and tags
	 */
	search: (term: string) =>
		apiClient.get<IBaseResponse<ISearch>>('/search', { params: { term } }),
};
